export const AMOUNT_ATTRIBUTE_OPTION_TYPE = 'AmountAttributeOption';
export const AMOUNT_ATTRIBUTE_OPTION_ID = 'Amount.options';

/**
 * @property {string} label
 * @property {number} value
 * @property {number} price
 */
export class AmountAttributeOption {
  constructor({ label, value, price }) {
    this.label = label;
    this.value = value;
    this.price = price;
    this.type = AMOUNT_ATTRIBUTE_OPTION_TYPE;
  }
}
